<template>
    <div
        class="fixed left-0 z-10 flex h-20 w-full items-center justify-center bg-slate-100 px-4 shadow-lg lg:px-0"
        :style="{ top: `${topBarHeight}px` }">
        <div
            class="tabs-scroll flex h-16 w-full flex-nowrap items-center justify-start gap-4 overflow-x-auto rounded-lg border border-gray-200 bg-white px-4 md:w-3/4">
            <div
                v-for="tab in tabs"
                :key="tab.id"
                :data-target-tab="tab.id"
                :data-target-tab-name="tab.name"
                :class="[
                    'flex h-10 w-auto shrink-0 cursor-pointer items-center justify-center space-x-2 rounded-md px-4 duration-150',
                    {
                        'bg-primary-500 text-white': tab.id === activeTab && !tab.locked,
                        'please-log-in bg-gray-200 text-gray-400': tab.locked,
                        'bg-transparent text-gray-500 hover:bg-gray-100': tab.id !== activeTab && !tab.locked,
                    },
                ]"
                @click="selectTab(tab)">
                <component :is="getTabIcon(tab.id)" class="h-4 w-4" />
                <p class="whitespace-nowrap text-sm">{{ tab.name }}</p>
                <LockIcon v-if="tab.locked" class="h-4 w-4" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import OverviewIcon from './asset/OverviewIcon.vue'
import DetailsIcon from './asset/DetailsIcon.vue'
import DocumentIcon from './asset/DocumentIcon.vue'
import NewsIcon from './asset/NewsIcon.vue'
import InvestorsRoomIcon from './asset/InvestorsRoomIcon.vue'
import LockIcon from './asset/LockIcon.vue'

const iconMap: Record<string, typeof OverviewIcon> = {
    overview: OverviewIcon,
    details: DetailsIcon,
    documents: DocumentIcon,
    investorsRoom: InvestorsRoomIcon,
    blog: NewsIcon,
}

const activeTab = ref('overview')
const topBarHeight = ref(0)
const tabs = ref<{ id: string; name: string; locked?: boolean; visible?: boolean }[]>([])

const getTabIcon = (tabId: string) => iconMap[tabId] ?? OverviewIcon

function selectTab(tab: { id: string; locked?: boolean }) {
    if (tab.locked) {
        window.dispatchEvent(new CustomEvent('open-login-modal'))
        return
    }
    activeTab.value = tab.id
    const tabContent = document.querySelectorAll('.tabcontent')
    tabContent.forEach((el) => ((el as HTMLElement).style.display = 'none'))
    const target = document.getElementById(tab.id)
    if (target) {
        ;(target as HTMLElement).style.display = 'block'
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}

onMounted(() => {
    const topBar = document.getElementById('main_menu_v2') as HTMLElement
    const rect = topBar.getBoundingClientRect()
    topBarHeight.value = rect.bottom
    tabs.value = window.condaCampaignTabs?.tabs.filter((tab: { visible?: boolean }) => tab.visible) ?? []
    if (tabs.value.length) activeTab.value = tabs.value[0].id
})
</script>

<style scoped>
.tabs-scroll {
    -ms-overflow-style: none;
    scrollbar-width: none;
}
.tabs-scroll::-webkit-scrollbar {
    display: none;
}
</style>
